import makeStyles from '@mui/styles/makeStyles';


export const LoginStyle = makeStyles((theme) => ({
	container: {
		position: "relative",
		display: "grid",
		placeItems: "center",
		minHeight: "100vh",
		padding: theme.spacing(4, 2),
		"--atl-blue": "#7ea2ff",
		"--atl-blue-dark": "#4f6fff",
		"--atl-cyan": "#6fd3ff",
		"--atl-teal": "#67d6d1",
		"--atl-text": "#eef6ff",
		"--atl-text-soft": "#b8c8d6",
		"--atl-text-muted": "#8ea1b2",
		"--atl-surface": "rgba(24, 31, 43, 0.74)",
		"--atl-surface-strong": "rgba(31, 40, 54, 0.9)",
		"--atl-surface-muted": "rgba(31, 40, 54, 0.56)",
		"--atl-border": "rgba(255, 255, 255, 0.11)",
		"--atl-border-strong": "rgba(255, 255, 255, 0.18)",
		"--atl-input": "rgba(31, 40, 54, 0.88)",
		"&:before": {
			content: '""',
			position: "fixed",
			inset: 0,
			background:
				"radial-gradient(circle at 24% 18%, rgba(79, 195, 247, 0.28), transparent 0 260px), radial-gradient(circle at 78% 12%, rgba(48, 79, 254, 0.28), transparent 0 300px), linear-gradient(180deg, rgba(5, 18, 30, 0.18), rgba(5, 18, 30, 0.42))",
			pointerEvents: "none",
		},
		[theme.breakpoints.down('sm')]: {
			padding: theme.spacing(2),
		},
	},
	paper: {
		position: "relative",
		width: "100%",
		maxWidth: 440,
		padding: theme.spacing(3, 0, 2.1),
		color: "#FFF !important",
		background: "linear-gradient(180deg, rgba(0, 72, 84, 0.84) 0%, rgba(0, 45, 43, 0.82) 100%) !important",
		border: "1px solid rgba(255, 255, 255, 0.2) !important",
		borderRadius: "22px !important",
		boxShadow: "0 24px 70px rgba(0, 28, 38, 0.38), inset 0 1px 0 rgba(255,255,255,0.22) !important",
		backdropFilter: "blur(18px) saturate(160%)",
		WebkitBackdropFilter: "blur(18px) saturate(160%)",
		overflow: "hidden",
		"&.MuiPaper-root": {
			borderRadius: "22px !important",
			background: "linear-gradient(180deg, rgba(0, 72, 84, 0.84) 0%, rgba(0, 45, 43, 0.82) 100%) !important",
			border: "1px solid rgba(255, 255, 255, 0.2) !important",
			boxShadow: "0 24px 70px rgba(0, 28, 38, 0.38), inset 0 1px 0 rgba(255,255,255,0.22) !important",
		},
		"&:before": {
			content: '""',
			position: "absolute",
			inset: 0,
			background: "radial-gradient(circle at top right, rgba(255,255,255,0.18), transparent 0 180px)",
			pointerEvents: "none",
		},
		[theme.breakpoints.down('sm')]: {
			maxWidth: "100%",
			padding: theme.spacing(3, 0, 2),
		},
	},
	paper404: {
		maxWidth: 420,
		height: 360,
		position: "absolute",
		left: "50%",
		top: "50%",
		transform: "translate(-50%, -50%)",
		border: "1px solid var(--atl-border) !important",
		background: "linear-gradient(180deg, var(--atl-surface-strong) 0%, var(--atl-surface) 100%) !important",
		boxShadow: "var(--atl-shadow-strong) !important",
		backdropFilter: "blur(14px) saturate(150%)",
		WebkitBackdropFilter: "blur(14px) saturate(150%)",
		[theme.breakpoints.down('lg')]: {
			width: "94%",
			height: 360,
			marginTop: theme.spacing(2),
		},
	},
	paperRegist: {
		borderRadius: "22px !important",
		maxWidth: 860,
		border: "1px solid var(--atl-border) !important",
		background: "linear-gradient(180deg, var(--atl-surface-strong) 0%, var(--atl-surface) 100%) !important",
		boxShadow: "var(--atl-shadow-strong) !important",
		backdropFilter: "blur(14px) saturate(150%)",
		WebkitBackdropFilter: "blur(14px) saturate(150%)",
		[theme.breakpoints.down('lg')]: {
			maxWidth: "100%",
		},
	},
	form: {
		position: "relative",
		zIndex: 1,
		width: "min(100% - 52px, 330px)",
		marginLeft: "auto",
		marginRight: "auto",
		[theme.breakpoints.down('sm')]: {
			width: "calc(100% - 32px)",
		},
	},
	loginStack: {
		display: "grid",
		gap: theme.spacing(1.15),
	},
	logoBlock: {
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		padding: theme.spacing(0.25, 0, 0.75),
	},
	fieldStack: {
		display: "grid",
		gap: theme.spacing(1.2),
		marginTop: theme.spacing(0.25),
	},
	linkStack: {
		display: "grid",
		gap: theme.spacing(0.75),
		marginTop: theme.spacing(0.5),
		color: "#fff",
		fontSize: 17,
		fontWeight: 650,
		textAlign: "center",
	},
	submit: {
		marginTop: theme.spacing(0.25),
		minHeight: 52,
		fontSize: 18,
		borderRadius: "14px !important",
		background: "linear-gradient(180deg, #12c8c1 0%, #008f98 100%) !important",
		color: "#fff !important",
		boxShadow: "0 16px 34px rgba(0, 168, 168, 0.28) !important",
		"&:hover": {
			background: "linear-gradient(180deg, #20d8d1 0%, #00a6ad 100%) !important",
		},
	},
	buttonRound: {
		borderRadius: 14
	},
	link: {
		color: "#14d6cf !important",
		cursor: "pointer",
		fontWeight: 800,
		textDecorationColor: "rgba(20, 214, 207, 0.42)",
	},
	margin: {
		marginTop: theme.spacing(1),
	},
	snackbar: {
		width: "100%",
		"& > * + *": {
			marginTop: theme.spacing(2),
		},
	},
	title: {
		margin: theme.spacing(1),
		textAlign: "center",
	},
	subTitle: {
		textAlign: "center",
		margin: theme.spacing(0, 0, 0.75),
		color: "rgba(255,255,255,0.86)",
		fontSize: 18,
		fontWeight: 750,
		lineHeight: 1.45,
		[theme.breakpoints.down('sm')]: {
			fontSize: 16,
		},
	},
	dialog: {
		borderRadius: 18
	},
	loginLogo: {
		width: "195px",
		maxWidth: "80%",
		filter: "drop-shadow(0 10px 24px rgba(0,0,0,0.18))",
		[theme.breakpoints.down('sm')]: {
			width: "220px",
		},
	},
	logo: {
		width: "300px",
	},
	flexGrid: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
	},
	input: {},
	loginField: {
		"& .MuiOutlinedInput-root": {
			minHeight: 52,
			borderRadius: "14px !important",
			background: "rgba(6, 33, 49, 0.28) !important",
			color: "#fff",
		},
		"& .MuiOutlinedInput-input": {
			padding: "14px 16px",
			color: "#fff",
			fontFamily: "Jost, Roboto, Helvetica Neue, Arial, sans-serif",
			fontSize: 17,
			fontWeight: 650,
			lineHeight: "24px",
			caretColor: "#14d6cf",
		},
		"& .MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(255, 255, 255, 0.24) !important",
		},
		"& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
			borderColor: "rgba(255, 255, 255, 0.46) !important",
		},
		"& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
			borderColor: "#ffffff !important",
		},
		"& .MuiInputLabel-root": {
			color: "rgba(255, 255, 255, 0.9) !important",
			fontWeight: 800,
		},
	},
	noAutocompleteStyle: {
		fontFamily: "Jost, Roboto, Helvetica Neue, Arial, sans-serif",
		fontSize: 17,
		fontWeight: 650,
		lineHeight: "24px",
		caretColor: "#14d6cf",
		WebkitTextFillColor: "#fff",
		"&:-webkit-autofill": {
			transition: "background-color 600000s 0s, color 600000s 0s",
			fontFamily: "Jost, Roboto, Helvetica Neue, Arial, sans-serif",
			fontSize: 17,
			fontWeight: 650,
			lineHeight: "24px",
			WebkitTextFillColor: "#fff",
			caretColor: "#14d6cf",
		},
		"&:-webkit-autofill:focus": {
			transition: "background-color 600000s 0s, color 600000s 0s",
			fontFamily: "Jost, Roboto, Helvetica Neue, Arial, sans-serif",
			fontSize: 17,
			fontWeight: 650,
			lineHeight: "24px",
			WebkitTextFillColor: "#fff",
			caretColor: "#14d6cf",
		},
		"&[data-autocompleted]": {
			backgroundColor: "transparent !important",
		},
		color: 'white',
	},
	capitalizeInput: {
		textTransform: "capitalize",
	},
}));
